import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import zhTw from 'element-plus/es/locale/lang/zh-tw'

import App from './App.vue'
import { router } from './router'
import { initTheme } from './composables/useTheme'
import { initIdleLogout } from './composables/useIdleLogout'
import './styles/tokens.css'
import './style.css'

initTheme()

const pinia = createPinia()

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhTw })
app.mount('#app')

initIdleLogout()   // 閒置 30 分鐘自動登出（需在 pinia 掛載後啟動）
